import {
  ClientAgencyTarget,
  CreateMarketTarget,
  MarketTarget,
  TargetParams,
} from "models/targets"

import { http } from "./http"

export const fetchMarketTargets = async (_key: string) => {
  const { data } = await http.get(`targets`).json<{ data: MarketTarget[] }>()
  return data
}

export const fetchMarketTargetParams = async (_key: string) => {
  const { data } = await http
    .get(`targets/params`)
    .json<{ data: TargetParams[] }>()
  return data
}

export const patchMarketTargetParams = async (pld: TargetParams) => {
  const { id, ...data } = pld
  return http.patch(`targets/params/${id}`, { json: data }).json() as any
}

export const createMarketTarget = async (pld: Partial<CreateMarketTarget>) => {
  const { ...body } = pld
  await http.post(`targets`, { json: body })
}

export const activateMarketTargets = async (pld: { targetId: string }) => {
  return await http.post(`targets/${pld.targetId}/activate`)
}

export const deactivateMarketTargets = async (pld: { targetId: string }) => {
  return await http.post(`targets/${pld.targetId}/deactivate`)
}

export const deleteMarketTargets = async (pld: { targetId: string }) => {
  await http.delete(`targets/${pld.targetId}`)
}

export const patchExternalCode = async (
  pld: Partial<MarketTarget>,
): Promise<MarketTarget> => {
  const { id, ...data } = pld
  return (await http.patch(`targets/${pld.id}`, { json: data })) as any
}

export const fetchAgencyClientTargets = async (
  _key: string,
  agencyClientConfigId?: string,
) => {
  const { data } = await http
    .get(`client-agency-configs/${agencyClientConfigId}/targets`)
    .json<{ data: ClientAgencyTarget[] }>()
  return data
}

export const toggleAgencyClientTargetActivation = async (
  pld: Partial<ClientAgencyTarget> & {
    clientAgencyConfigId?: string
    targetId: string
  },
) => {
  const { clientAgencyConfigId, targetId, enabled } = pld
  const action = enabled ? "enable" : "disable"
  const res = http
    .post(
      `client-agency-configs/${clientAgencyConfigId}/targets/${targetId}/${action}`,
    )
    .json()
  return res as Partial<ClientAgencyTarget>
}
